(function() {
    const baseW = 820;	//基準となるブレークポイント
    const baseH = 430;	//基準となるブレークポイント
    let iOSViewportW = 0;
    const ua = navigator.userAgent.toLowerCase();
    const isiOS = (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1) || (ua.indexOf("ipad") > -1);
    if(isiOS){
        iOSViewportW = document.documentElement.clientWidth;
        iOSViewportH = document.documentElement.clientHeight;
    }
    function updateMetaViewport(){
        let viewportContent;
        let w = window.outerWidth;
        let h = window.outerHeight;
        if(isiOS){
            w = iOSViewportW;
            h = iOSViewportH;
            if(!(window.orientation % 180 == 0)){
                [w, h] = [h, w];
            }
        }
        if(h < baseH){ // 画面高が低い場合（スマートフォン横向きを想定）
            viewportContent = "width=" + 1240 + ",user-scalable=yes,shrink-to-fit=no";
        }else if(w < baseW){ // 画面幅が狭い場合（iPad未満を想定）
            viewportContent = "width=" + baseW + ",user-scalable=yes,shrink-to-fit=no";
        }else{
            viewportContent = "width=device-width,user-scalable=no,shrink-to-fit=yes";
        }
        document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent);
    }
    //イベントハンドラ登録
    window.addEventListener("resize", updateMetaViewport, false);
    window.addEventListener("orientationchange", updateMetaViewport, false);
    //初回イベント強制発動
    const ev = document.createEvent("UIEvent");
    ev.initEvent("resize", true, true)
    window.dispatchEvent(ev);
})();